export const REGIONS_MAP = {
  brazil: 'brazil',
  mexico: 'mexico',
  argentina: 'argentina',
  paraguay: 'argentina',
  uruguay: 'argentina'
};
